import { toast } from "react-toastify";
import axiosInstance from "./axiosInstance";
import { ROUTES } from "../utils/consts/routes";
import { AxiosRequestConfig } from "axios";

export const getFetcher = (
  url: string,
  returnFullResponse?: boolean,
  options?: AxiosRequestConfig,
) =>
  axiosInstance
    .get(url, options)
    .then((res) => (returnFullResponse ? res : res?.data?.data ? res?.data?.data : res?.data))
    .catch((error) => {
      if (error?.response?.status === 401) {
        localStorage.removeItem("accessToken");
        window.location.href = ROUTES.home;
      }
      toast.error(error?.response?.data?.message);
    });

export const postFetcher = (
  url: string,
  { arg }: { arg: unknown },
  hideToast?: boolean,
  errorProperty?: string,
) =>
  axiosInstance
    .post(url, arg)
    .then((res) => res?.data)
    .catch((error) => {
      if (hideToast) {
        return;
      }

      if (errorProperty && error?.response?.data) {
        toast.error(error?.response?.data.errors?.[errorProperty]?.[0].message);
        return;
      }

      toast.error(
        // show custom validation error else default to generic response
        error?.response?.data?.errors?.[0]?.[0]?.message ??
          error?.response?.data?.message ??
          error?.response?.data?.error,
      );
    });

export const putFetcher = (
  url: string,
  { arg }: { arg: { resourceId?: string | number; params?: string; [key: string]: unknown } },
  hideToast?: boolean,
) =>
  axiosInstance
    .put(arg?.resourceId ? `${url}/${arg.resourceId}${arg.params ?? ""}` : url, arg)
    .then((response) => response.data)
    .catch((error) => {
      if (!hideToast) {
        toast.error(
          error?.response?.data?.errors?.[0]?.[0]?.message ??
            error?.response?.data?.message ??
            error?.response?.data?.error,
        );
      }
    });
